var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.542206,
    y: 0.542969,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#0071E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.542206,
    y: 0.542969,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7543 7.13086H7.70974C7.40325 7.13086 7.10932 7.25261 6.89261 7.46933C6.67589 7.68604 6.55414 7.97997 6.55414 8.28646V16.3757C6.55414 16.6821 6.67589 16.9761 6.89261 17.1928C7.10932 17.4095 7.40325 17.5313 7.70974 17.5313H15.7989C16.1054 17.5313 16.3994 17.4095 16.6161 17.1928C16.8328 16.9761 16.9545 16.6821 16.9545 16.3757V12.3311",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4377 6.91369C15.6676 6.68382 15.9793 6.55469 16.3044 6.55469C16.6295 6.55469 16.9413 6.68382 17.1711 6.91369C17.401 7.14355 17.5301 7.45531 17.5301 7.78039C17.5301 8.10546 17.401 8.41722 17.1711 8.64709L11.9634 13.8554C11.8262 13.9925 11.6567 14.0928 11.4705 14.1472L9.81053 14.6325C9.76081 14.647 9.70811 14.6479 9.65794 14.635C9.60777 14.6222 9.56197 14.5961 9.52535 14.5595C9.48873 14.5228 9.46263 14.477 9.44977 14.4269C9.43692 14.3767 9.43779 14.324 9.45229 14.2743L9.93764 12.6143C9.99226 12.4282 10.0928 12.2589 10.23 12.122L15.4377 6.91369Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0d1bd84823749bd8d82041de7a318550.svg";
export { ForwardRef as ReactComponent };